import script from "./Payment.vue?vue&type=script&setup=true&lang=js"
export * from "./Payment.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import BasicSpinner from "@/components/BasicSpinner.vue";
import NeueButton from "@/components/neue/NeueButton.vue";
import SelectInput from "@/components/neue/SelectInput.vue";
script.components = Object.assign({}, { BasicSpinner, NeueButton, SelectInput }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { BasicSpinner, NeueButton, SelectInput }, script.__o.components);}